import { Entity } from './entity';

export type Partner = Entity;

export const PartnerCollection = 'partners';
